import { useEffect, useState, useMemo } from 'react';
import { useContentStore } from "../../providers/stores/content-store";
import { isNullOrEmpty, isNullOrUndefined } from '../../helpers';
import { ValidationMessages } from '../common/ValidationMessages';
import { AccountApi } from '../../api';

import logger from 'debug';

const debug = logger('login:passwordReset');

export const PasswordReset = (props) => {
	const authenticationContent = useContentStore(state => state.authenticationContent(state));
	const sharedContent = useContentStore(state => state.sharedContent(state));

	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [validation, setValidation] = useState([]);
	const [isSuccess, setIsSuccess] = useState(false);

	const token = useMemo(() => {
		let params = new URLSearchParams(document.location.search);
		return params.get('token');
	}, [])

	useEffect(() => {
		initPasswordReset();
	}, []);

	const processResponse = (apiResponse) => {
		if (!isNullOrUndefined(apiResponse.error)) {
			const { data } = apiResponse;
			let response = JSON.parse(data);
			setValidation(response.messages);
		}
		else {
			setIsSuccess(apiResponse.isValid);
			setValidation(apiResponse.messages);
		}
	}

	const initPasswordReset = async () => {
		let apiResponse = await AccountApi.validatePasswordResetToken({ token });

		processResponse(apiResponse);
	};

	const onFormSubmit = async (event) => {
		event.preventDefault();

		let apiResponse = await AccountApi.passwordReset({ token, password, confirmPassword });
		processResponse(apiResponse);
	}

	return (
		<form id="password-form" onSubmit={onFormSubmit} className="pad20 clearfix">
			<h1>Reset Password</h1>

			<label>{authenticationContent.passwordLabel}</label>
			<div className="textWrapper">
				<input name="password" type="password" autoComplete="new-password" value={password} onChange={(event) => setPassword(event.target.value)} />
			</div>
			<div>Enter desired password.</div>

			<label>{authenticationContent.confirmPasswordLabel}</label>
			<div className="textWrapper">
				<input name="confirmPassword" type="password" autoComplete="new-password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} />
			</div>
			<div>Re-enter password.</div>

			{!isNullOrEmpty(validation) &&
				<ValidationMessages
					className={isSuccess ? '' : ''}
					header={isSuccess ? '' : 'Error(s):'}
					messages={validation} />
			}
			<button type="submit">{sharedContent.submitButton}</button>
		</form>
	);
};